import apiBase from "@/api/unversioned/apiBase";
import { type AxiosRequestConfig } from "axios";
import type { SessionRequest, BatchRequest } from "./types";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/carrier/performance/transit/target`;

const getTemplateUrl = (transportMode: string) =>
  `${baseURL}/template?transportMode=${encodeURIComponent(transportMode)}`;

const createSession = async (body: SessionRequest, config?: AxiosRequestConfig) => {
  return apiBase("post", `${baseURL}/upload/session`, config, body);
};

const uploadBatch = async (body: BatchRequest, config?: AxiosRequestConfig) => {
  return apiBase("put", `${baseURL}/upload/batch`, config, body);
};

const getErrorReport = async (sessionId: string, config?: AxiosRequestConfig) => {
  return apiBase("get", `${baseURL}/upload/${encodeURIComponent(sessionId)}/report`, config);
};

const getTargetCoverage = async (transportMode: string, config?: AxiosRequestConfig) => {
  return apiBase("get", `${baseURL}/coverage?transportMode=${encodeURIComponent(transportMode)}`, config);
};

export { getTemplateUrl, createSession, uploadBatch, getErrorReport, getTargetCoverage };
